import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

import ProductDetail from "@components/ProductDetail";
import Information from "@components/Information";
import { getResultDetailProduct } from "@dataLayer/product";

import './index.scss';
import { useTranslation } from "react-i18next";

const ResultDetailPage = () => {
  const { t } = useTranslation();
  const { cp_id } = useParams();
  const { data: product } = useQuery(getResultDetailProduct(cp_id));

  useEffect(() => {
    document.title = t("title.result_detail");
  }, [t]);

  return (
    <div className="result-detail-page">
      <div className="result-detail-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            <ProductDetail
              product={product}
              isWinner={product?.status !== 5}
              isNoOneWinner={product?.status === 5}
              isPotentialWinner={false}
            />
            <Information product={product} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ResultDetailPage;
